import { Component, OnInit } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { CallService } from 'src/app/call.service';
import { MediaDevicePermissionWatcherService } from 'src/app/media-device-permission-watcher.service';

@Component({
  selector: 'app-call-device-controller',
  templateUrl: './call-device-controller.component.html',
  styleUrls: ['./call-device-controller.component.css'],
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, MatOptionModule, MatIconModule],
})
export class CallDeviceControllerComponent implements OnInit {
  cameras = [];
  microphones = [];
  selectedCamera: any;
  selectedMicrophone: any;

  constructor(
    private callService: CallService,
    private permissionService: MediaDevicePermissionWatcherService
  ) {}

  ngOnInit(): void {
    this.fetchCameras();
  }
  requestMicrophoneAccess() {
    return this.permissionService.requestMicrophoneAccess();
  }

  requestCameraAccess() {
    return this.permissionService.requestCameraAccess();
  }

  fetchCameras(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      await this.requestMicrophoneAccess();
      await this.requestCameraAccess();
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          this.cameras = devices.filter((device) => device.kind === 'videoinput' && device.deviceId.length);
          this.microphones = devices.filter((device) => device.kind === 'audioinput' && device.deviceId.length);
          if (!this.cameras.length) {
            localStorage.removeItem('selectedCamera');
          } else {
            this.selectedCamera = localStorage.getItem('selectedCamera') || this.cameras[0].deviceId;
            localStorage.setItem('selectedCamera', this.selectedCamera);
            this.callService.updateCameraStream();
          }
          if (!this.microphones.length) {
            localStorage.removeItem('selectedMicrophone');
          } else {
            this.selectedMicrophone = localStorage.getItem('selectedMicrophone') || this.microphones[0].deviceId;
            localStorage.setItem('selectedMicrophone', this.selectedMicrophone);
            this.callService.updateCameraStream();
          }
          resolve();
        })
        .catch((err) => {
          console.error('enum error access', err);
          console.error(err);
          reject(err);
        });
    });
  }

  onCameraChange(event: any): void {
    this.selectedCamera = event.value;
    localStorage.setItem('selectedCamera', event.value);
    this.callService.passDeviceChange({
      camera: event.value,
    });
    this.callService.updateCameraStream();
  }

  onMicrophoneChange(event: any): void {
    this.selectedMicrophone = event.value;
    localStorage.setItem('selectedMicrophone', event.value);
    this.callService.passDeviceChange({
      microphone: event.value,
    });
    this.callService.updateCameraStream();
  }
}
